import type { ReactNode } from 'react';
import { BrandMark } from './AppShell';

const PRODUCT_NAME = 'microapp基盤';

export interface WorkspaceShellProps {
  /** ブランドから戻る先（Workspace一覧）。URLの組み立てはrouterの責務。 */
  brandHref: string;
  /** ブランド行の下に並べるナビ。.nav-item クラスを使う。 */
  sidebar?: ReactNode;
  /** 渡したときだけサイドバーの最下部にログアウトを出す。認証が無効なlocalでは渡さない。 */
  onLogout?: () => void;
  children: ReactNode;
}

/**
 * Workspace一覧・Workspace詳細まわりの外枠。暗色サイドバー＋明色mainの2領域。
 * AppShellと別部品にしているのは、microapp詳細（ヘッダー＋stage）と
 * 管理ページ（サイドバー＋main）で領域の構成そのものが違うため。
 */
export function WorkspaceShell({ brandHref, sidebar, onLogout, children }: WorkspaceShellProps) {
  return (
    <div className="workspace-shell">
      <aside className="workspace-shell-sidebar">
        <a className="workspace-shell-brand" href={brandHref}>
          <BrandMark />
          <span>{PRODUCT_NAME}</span>
        </a>
        {sidebar}
        {onLogout === undefined ? null : (
          <div className="workspace-shell-foot">
            <button type="button" className="nav-item" onClick={onLogout}>
              ログアウト
            </button>
          </div>
        )}
      </aside>
      <div className="workspace-shell-main">
        <main className="workspace-shell-body">{children}</main>
      </div>
    </div>
  );
}
